import { useEffect } from "react";

const useScroll = () => {
  useEffect(() => {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }, []);
};

export default useScroll;
